/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  SectionPrivilage,
  ErrorInfo,
  GetSectionFirstId200,
  GetSectionFirstIdParams,
  Section,
  PostSectionSave200,
  PostSectionsUpload200,
  PostSectionsUploadBody,
  BinaryFile,
  PostSectionsRecspec200,
  PostSectionsRecspecBody,
  PostSectionPreview200,
  PostSectionPreviewBody,
  PostSectionDownloadBody,
  OriSearchResult,
  OriSearchConditions,
  OriSearchMasters,
  PostSectionsOridownloadBody,
  PostSectionPss200,
  PostSectionPssBody,
  PostSectionPsinfo200,
  PostSectionPsinfoBody,
  PostSectionCopy200,
  PostSectionCopyBody,
  PostSectionsLogcheck200,
  ImageSourceValidationResult,
  PostSectionsImgcheckBody,
  HeadingIdValidationResult,
  PostSectionsHeadingidcheckBody,
  SectionIdValidationResult,
  PostSectionsSectionidcheckBody,
  SectionPsDiffCheckResult,
  PostSectionsPsdiffcheckBody,
  PutSectionsUpdateRevisionTitle200,
  PutSectionsUpdateRevisionTitleBody,
  GetCkeditorReplacements200Item
} from '.././model'


/**
 * タブの権限情報
 * @summary タブの権限情報
 */
export const getSectionPrivilege = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SectionPrivilage>> => {
    return axios.get(
      `/sections/privilege`,options
    );
  }


export const getGetSectionPrivilegeQueryKey = () => [`/sections/privilege`];

    
export type GetSectionPrivilegeQueryResult = NonNullable<Awaited<ReturnType<typeof getSectionPrivilege>>>
export type GetSectionPrivilegeQueryError = AxiosError<ErrorInfo>

export const useGetSectionPrivilege = <TData = Awaited<ReturnType<typeof getSectionPrivilege>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSectionPrivilege>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSectionPrivilegeQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSectionPrivilege>>> = ({ signal }) => getSectionPrivilege({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getSectionPrivilege>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * セクションの編集ロック処理。

 * @summary セクション編集ロック
 */
export const postSectionLock = (
    sectionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/sections/${sectionId}/lock`,undefined,options
    );
  }



    export type PostSectionLockMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionLock>>>
    
    export type PostSectionLockMutationError = AxiosError<ErrorInfo>

    export const usePostSectionLock = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionLock>>, TError,{sectionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionLock>>, {sectionId: number}> = (props) => {
          const {sectionId} = props ?? {};

          return  postSectionLock(sectionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionLock>>, TError, {sectionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * セクション編集ロックを解除する。

 * @summary セクション編集ロック解除
 */
export const postSectionUnlock = (
    sectionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    return axios.post(
      `/sections/${sectionId}/unlock`,undefined,options
    );
  }



    export type PostSectionUnlockMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionUnlock>>>
    
    export type PostSectionUnlockMutationError = AxiosError<ErrorInfo>

    export const usePostSectionUnlock = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionUnlock>>, TError,{sectionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionUnlock>>, {sectionId: number}> = (props) => {
          const {sectionId} = props ?? {};

          return  postSectionUnlock(sectionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionUnlock>>, TError, {sectionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * セクションIDを取得する
 * @summary 1章先頭L2のセクションIDを取得
 */
export const getSectionFirstId = (
    params: GetSectionFirstIdParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetSectionFirstId200>> => {
    return axios.get(
      `/sections/firstId`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }


export const getGetSectionFirstIdQueryKey = (params: GetSectionFirstIdParams,) => [`/sections/firstId`, ...(params ? [params]: [])];

    
export type GetSectionFirstIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSectionFirstId>>>
export type GetSectionFirstIdQueryError = AxiosError<ErrorInfo>

export const useGetSectionFirstId = <TData = Awaited<ReturnType<typeof getSectionFirstId>>, TError = AxiosError<ErrorInfo>>(
 params: GetSectionFirstIdParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSectionFirstId>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSectionFirstIdQueryKey(params);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSectionFirstId>>> = ({ signal }) => getSectionFirstId(params, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getSectionFirstId>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * セクションを取得する。

 * @summary セクション取得
 */
export const getSection = (
    sectionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Section>> => {
    return axios.get(
      `/sections/${sectionId}`,options
    );
  }


export const getGetSectionQueryKey = (sectionId: number,) => [`/sections/${sectionId}`];

    
export type GetSectionQueryResult = NonNullable<Awaited<ReturnType<typeof getSection>>>
export type GetSectionQueryError = AxiosError<ErrorInfo>

export const useGetSection = <TData = Awaited<ReturnType<typeof getSection>>, TError = AxiosError<ErrorInfo>>(
 sectionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSection>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSectionQueryKey(sectionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSection>>> = ({ signal }) => getSection(sectionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getSection>>, TError, TData>(queryKey, queryFn, {enabled: !!(sectionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * セクションの保存。編集ロックは継続する。

 * @summary セクション保存。編集ロックは継続。
 */
export const postSectionSave = (
    sectionId: number,
    section: Section, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostSectionSave200>> => {
    return axios.post(
      `/sections/${sectionId}/save`,
      section,options
    );
  }



    export type PostSectionSaveMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionSave>>>
    export type PostSectionSaveMutationBody = Section
    export type PostSectionSaveMutationError = AxiosError<ErrorInfo>

    export const usePostSectionSave = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionSave>>, TError,{sectionId: number;data: Section}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionSave>>, {sectionId: number;data: Section}> = (props) => {
          const {sectionId,data} = props ?? {};

          return  postSectionSave(sectionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionSave>>, TError, {sectionId: number;data: Section}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 原稿編集画面でコメント添付ファイルをアップロードする。

 * @summary コメントアップロード
 */
export const postSectionsUpload = (
    productionId: number,
    postSectionsUploadBody: PostSectionsUploadBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostSectionsUpload200>> => {const formData = new FormData();
if(postSectionsUploadBody.file !== undefined) {
 formData.append('file', postSectionsUploadBody.file)
 }

    return axios.post(
      `/sections/commentUpload/${productionId}`,
      formData,options
    );
  }



    export type PostSectionsUploadMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionsUpload>>>
    export type PostSectionsUploadMutationBody = PostSectionsUploadBody
    export type PostSectionsUploadMutationError = AxiosError<ErrorInfo>

    export const usePostSectionsUpload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionsUpload>>, TError,{productionId: number;data: PostSectionsUploadBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionsUpload>>, {productionId: number;data: PostSectionsUploadBody}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postSectionsUpload(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionsUpload>>, TError, {productionId: number;data: PostSectionsUploadBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * コメント添付データ取得(署名付きURLによるアクセスが必要)

 * @summary コメント添付データ取得
 */
export const getSectionsDownload = (
    productionId: number,
    commentAttachedFileId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.get(
      `/sections/commentDownload/${productionId}/${commentAttachedFileId}`,options
    );
  }


export const getGetSectionsDownloadQueryKey = (productionId: number,
    commentAttachedFileId: number,) => [`/sections/commentDownload/${productionId}/${commentAttachedFileId}`];

    
export type GetSectionsDownloadQueryResult = NonNullable<Awaited<ReturnType<typeof getSectionsDownload>>>
export type GetSectionsDownloadQueryError = AxiosError<ErrorInfo>

export const useGetSectionsDownload = <TData = Awaited<ReturnType<typeof getSectionsDownload>>, TError = AxiosError<ErrorInfo>>(
 productionId: number,
    commentAttachedFileId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSectionsDownload>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSectionsDownloadQueryKey(productionId,commentAttachedFileId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSectionsDownload>>> = ({ signal }) => getSectionsDownload(productionId,commentAttachedFileId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getSectionsDownload>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId && commentAttachedFileId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * RecSpecファイルを読込んでidを返す

 * @summary RecSpec連携
 */
export const postSectionsRecspec = (
    sectionId: number,
    postSectionsRecspecBody: PostSectionsRecspecBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostSectionsRecspec200>> => {const formData = new FormData();
if(postSectionsRecspecBody.file !== undefined) {
 formData.append('file', postSectionsRecspecBody.file)
 }

    return axios.post(
      `/sections/recspec/${sectionId}`,
      formData,options
    );
  }



    export type PostSectionsRecspecMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionsRecspec>>>
    export type PostSectionsRecspecMutationBody = PostSectionsRecspecBody
    export type PostSectionsRecspecMutationError = AxiosError<ErrorInfo>

    export const usePostSectionsRecspec = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionsRecspec>>, TError,{sectionId: number;data: PostSectionsRecspecBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionsRecspec>>, {sectionId: number;data: PostSectionsRecspecBody}> = (props) => {
          const {sectionId,data} = props ?? {};

          return  postSectionsRecspec(sectionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionsRecspec>>, TError, {sectionId: number;data: PostSectionsRecspecBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * セクション単位のドキュメントを作成して、プレビュー表示する

 * @summary ドキュメントを作成する
 */
export const postSectionPreview = (
    postSectionPreviewBody: PostSectionPreviewBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostSectionPreview200>> => {
    return axios.post(
      `/sections/preview`,
      postSectionPreviewBody,options
    );
  }



    export type PostSectionPreviewMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionPreview>>>
    export type PostSectionPreviewMutationBody = PostSectionPreviewBody
    export type PostSectionPreviewMutationError = AxiosError<ErrorInfo>

    export const usePostSectionPreview = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionPreview>>, TError,{data: PostSectionPreviewBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionPreview>>, {data: PostSectionPreviewBody}> = (props) => {
          const {data} = props ?? {};

          return  postSectionPreview(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionPreview>>, TError, {data: PostSectionPreviewBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ドキュメントを作成しダウンロードする

 * @summary ドキュメントを作成する
 */
export const postSectionDownload = (
    postSectionDownloadBody: PostSectionDownloadBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/sections/download`,
      postSectionDownloadBody,options
    );
  }



    export type PostSectionDownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionDownload>>>
    export type PostSectionDownloadMutationBody = PostSectionDownloadBody
    export type PostSectionDownloadMutationError = AxiosError<ErrorInfo>

    export const usePostSectionDownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionDownload>>, TError,{data: PostSectionDownloadBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionDownload>>, {data: PostSectionDownloadBody}> = (props) => {
          const {data} = props ?? {};

          return  postSectionDownload(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionDownload>>, TError, {data: PostSectionDownloadBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ORIデータ検索

 * @summary ORIデータ検索
 */
export const postSectionsOrisearch = (
    oriSearchConditions: OriSearchConditions, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OriSearchResult>> => {
    return axios.post(
      `/sections/oriSearch`,
      oriSearchConditions,options
    );
  }



    export type PostSectionsOrisearchMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionsOrisearch>>>
    export type PostSectionsOrisearchMutationBody = OriSearchConditions
    export type PostSectionsOrisearchMutationError = AxiosError<ErrorInfo>

    export const usePostSectionsOrisearch = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionsOrisearch>>, TError,{data: OriSearchConditions}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionsOrisearch>>, {data: OriSearchConditions}> = (props) => {
          const {data} = props ?? {};

          return  postSectionsOrisearch(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionsOrisearch>>, TError, {data: OriSearchConditions}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ORI検索に必要なマスタを一括取得して返す。

 * @summary マスタ一括取得
 */
export const getSectionsOrisearchMasters = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<OriSearchMasters>> => {
    return axios.get(
      `/sections/oriSearch/masters`,options
    );
  }


export const getGetSectionsOrisearchMastersQueryKey = () => [`/sections/oriSearch/masters`];

    
export type GetSectionsOrisearchMastersQueryResult = NonNullable<Awaited<ReturnType<typeof getSectionsOrisearchMasters>>>
export type GetSectionsOrisearchMastersQueryError = AxiosError<ErrorInfo>

export const useGetSectionsOrisearchMasters = <TData = Awaited<ReturnType<typeof getSectionsOrisearchMasters>>, TError = AxiosError<ErrorInfo>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getSectionsOrisearchMasters>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSectionsOrisearchMastersQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSectionsOrisearchMasters>>> = ({ signal }) => getSectionsOrisearchMasters({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getSectionsOrisearchMasters>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * ORIデータ検索

 * @summary ORIデータ出力
 */
export const postSectionsOridownload = (
    postSectionsOridownloadBody: PostSectionsOridownloadBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/sections/oriDownload`,
      postSectionsOridownloadBody,options
    );
  }



    export type PostSectionsOridownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionsOridownload>>>
    export type PostSectionsOridownloadMutationBody = PostSectionsOridownloadBody
    export type PostSectionsOridownloadMutationError = AxiosError<ErrorInfo>

    export const usePostSectionsOridownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionsOridownload>>, TError,{data: PostSectionsOridownloadBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionsOridownload>>, {data: PostSectionsOridownloadBody}> = (props) => {
          const {data} = props ?? {};

          return  postSectionsOridownload(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionsOridownload>>, TError, {data: PostSectionsOridownloadBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PSコンテンツを取得する

 * @summary PSコンテンツを取得する
 */
export const postSectionPss = (
    postSectionPssBody: PostSectionPssBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostSectionPss200>> => {
    return axios.post(
      `/sections/pss`,
      postSectionPssBody,options
    );
  }



    export type PostSectionPssMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionPss>>>
    export type PostSectionPssMutationBody = PostSectionPssBody
    export type PostSectionPssMutationError = AxiosError<ErrorInfo>

    export const usePostSectionPss = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionPss>>, TError,{data: PostSectionPssBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionPss>>, {data: PostSectionPssBody}> = (props) => {
          const {data} = props ?? {};

          return  postSectionPss(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionPss>>, TError, {data: PostSectionPssBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PSバージョンIDからPSの情報を取得

 * @summary PSバージョンIDからPSの情報を取得
 */
export const postSectionPsinfo = (
    postSectionPsinfoBody: PostSectionPsinfoBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostSectionPsinfo200>> => {
    return axios.post(
      `/sections/psinfo`,
      postSectionPsinfoBody,options
    );
  }



    export type PostSectionPsinfoMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionPsinfo>>>
    export type PostSectionPsinfoMutationBody = PostSectionPsinfoBody
    export type PostSectionPsinfoMutationError = AxiosError<ErrorInfo>

    export const usePostSectionPsinfo = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionPsinfo>>, TError,{data: PostSectionPsinfoBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionPsinfo>>, {data: PostSectionPsinfoBody}> = (props) => {
          const {data} = props ?? {};

          return  postSectionPsinfo(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionPsinfo>>, TError, {data: PostSectionPsinfoBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * ORIデータを取得

 * @summary ORIデータを取得
 */
export const postSectionCopy = (
    sectionId: number,
    postSectionCopyBody: PostSectionCopyBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostSectionCopy200>> => {
    return axios.post(
      `/sections/${sectionId}/copy`,
      postSectionCopyBody,options
    );
  }



    export type PostSectionCopyMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionCopy>>>
    export type PostSectionCopyMutationBody = PostSectionCopyBody
    export type PostSectionCopyMutationError = AxiosError<ErrorInfo>

    export const usePostSectionCopy = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionCopy>>, TError,{sectionId: number;data: PostSectionCopyBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionCopy>>, {sectionId: number;data: PostSectionCopyBody}> = (props) => {
          const {sectionId,data} = props ?? {};

          return  postSectionCopy(sectionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionCopy>>, TError, {sectionId: number;data: PostSectionCopyBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 原稿編集のエラーログをダウンロード

 * @summary 原稿編集のエラーログをダウンロード
 */
export const postSectionsLogdownload = (
    sectionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/sections/${sectionId}/logdownload`,undefined,options
    );
  }



    export type PostSectionsLogdownloadMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionsLogdownload>>>
    
    export type PostSectionsLogdownloadMutationError = AxiosError<ErrorInfo>

    export const usePostSectionsLogdownload = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionsLogdownload>>, TError,{sectionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionsLogdownload>>, {sectionId: number}> = (props) => {
          const {sectionId} = props ?? {};

          return  postSectionsLogdownload(sectionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionsLogdownload>>, TError, {sectionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 原稿編集のエラーログをダウンロード

 * @summary 原稿編集のエラーログをダウンロード
 */
export const postSectionsLogcheck = (
    sectionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostSectionsLogcheck200>> => {
    return axios.get(
      `/sections/${sectionId}/logcheck`,options
    );
  }


export const getPostSectionsLogcheckQueryKey = (sectionId: number,) => [`/sections/${sectionId}/logcheck`];

    
export type PostSectionsLogcheckQueryResult = NonNullable<Awaited<ReturnType<typeof postSectionsLogcheck>>>
export type PostSectionsLogcheckQueryError = AxiosError<ErrorInfo>

export const usePostSectionsLogcheck = <TData = Awaited<ReturnType<typeof postSectionsLogcheck>>, TError = AxiosError<ErrorInfo>>(
 sectionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof postSectionsLogcheck>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPostSectionsLogcheckQueryKey(sectionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof postSectionsLogcheck>>> = ({ signal }) => postSectionsLogcheck(sectionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof postSectionsLogcheck>>, TError, TData>(queryKey, queryFn, {enabled: !!(sectionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 画像のsrc属性のチェック（複数）を行う。それぞれに対してエラーがあればエラー内容を返す。
 * @summary 画像のsrc属性のチェック（複数）
 */
export const postSectionsImgcheck = (
    sectionId: number,
    postSectionsImgcheckBody: PostSectionsImgcheckBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<ImageSourceValidationResult[]>> => {
    return axios.post(
      `/sections/${sectionId}/imgcheck`,
      postSectionsImgcheckBody,options
    );
  }



    export type PostSectionsImgcheckMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionsImgcheck>>>
    export type PostSectionsImgcheckMutationBody = PostSectionsImgcheckBody
    export type PostSectionsImgcheckMutationError = AxiosError<ErrorInfo>

    export const usePostSectionsImgcheck = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionsImgcheck>>, TError,{sectionId: number;data: PostSectionsImgcheckBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionsImgcheck>>, {sectionId: number;data: PostSectionsImgcheckBody}> = (props) => {
          const {sectionId,data} = props ?? {};

          return  postSectionsImgcheck(sectionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionsImgcheck>>, TError, {sectionId: number;data: PostSectionsImgcheckBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * h?のid属性のチェック（複数）を行う。それぞれに対してエラーがあればエラー内容を返す。
 * @summary h?のid属性のチェック（複数）
 */
export const postSectionsHeadingidcheck = (
    sectionId: number,
    postSectionsHeadingidcheckBody: PostSectionsHeadingidcheckBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<HeadingIdValidationResult[]>> => {
    return axios.post(
      `/sections/${sectionId}/headingidcheck`,
      postSectionsHeadingidcheckBody,options
    );
  }



    export type PostSectionsHeadingidcheckMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionsHeadingidcheck>>>
    export type PostSectionsHeadingidcheckMutationBody = PostSectionsHeadingidcheckBody
    export type PostSectionsHeadingidcheckMutationError = AxiosError<ErrorInfo>

    export const usePostSectionsHeadingidcheck = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionsHeadingidcheck>>, TError,{sectionId: number;data: PostSectionsHeadingidcheckBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionsHeadingidcheck>>, {sectionId: number;data: PostSectionsHeadingidcheckBody}> = (props) => {
          const {sectionId,data} = props ?? {};

          return  postSectionsHeadingidcheck(sectionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionsHeadingidcheck>>, TError, {sectionId: number;data: PostSectionsHeadingidcheckBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * section_id属性のチェック（複数）を行う。それぞれに対してエラーがあればエラー内容を返す。
 * @summary section_id属性のチェック（複数）
 */
export const postSectionsSectionidcheck = (
    sectionId: number,
    postSectionsSectionidcheckBody: PostSectionsSectionidcheckBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SectionIdValidationResult[]>> => {
    return axios.post(
      `/sections/${sectionId}/sectionidcheck`,
      postSectionsSectionidcheckBody,options
    );
  }



    export type PostSectionsSectionidcheckMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionsSectionidcheck>>>
    export type PostSectionsSectionidcheckMutationBody = PostSectionsSectionidcheckBody
    export type PostSectionsSectionidcheckMutationError = AxiosError<ErrorInfo>

    export const usePostSectionsSectionidcheck = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionsSectionidcheck>>, TError,{sectionId: number;data: PostSectionsSectionidcheckBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionsSectionidcheck>>, {sectionId: number;data: PostSectionsSectionidcheckBody}> = (props) => {
          const {sectionId,data} = props ?? {};

          return  postSectionsSectionidcheck(sectionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionsSectionidcheck>>, TError, {sectionId: number;data: PostSectionsSectionidcheckBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * PS差異チェックを行う
 * @summary PS差異チェック
 */
export const postSectionsPsdiffcheck = (
    sectionId: number,
    postSectionsPsdiffcheckBody: PostSectionsPsdiffcheckBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<SectionPsDiffCheckResult>> => {
    return axios.post(
      `/sections/${sectionId}/psdiffcheck`,
      postSectionsPsdiffcheckBody,options
    );
  }



    export type PostSectionsPsdiffcheckMutationResult = NonNullable<Awaited<ReturnType<typeof postSectionsPsdiffcheck>>>
    export type PostSectionsPsdiffcheckMutationBody = PostSectionsPsdiffcheckBody
    export type PostSectionsPsdiffcheckMutationError = AxiosError<ErrorInfo>

    export const usePostSectionsPsdiffcheck = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSectionsPsdiffcheck>>, TError,{sectionId: number;data: PostSectionsPsdiffcheckBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSectionsPsdiffcheck>>, {sectionId: number;data: PostSectionsPsdiffcheckBody}> = (props) => {
          const {sectionId,data} = props ?? {};

          return  postSectionsPsdiffcheck(sectionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postSectionsPsdiffcheck>>, TError, {sectionId: number;data: PostSectionsPsdiffcheckBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 改訂履歴のタイトルを更新する
 * @summary 改訂履歴のタイトル更新
 */
export const putSectionsUpdateRevisionTitle = (
    putSectionsUpdateRevisionTitleBody: PutSectionsUpdateRevisionTitleBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PutSectionsUpdateRevisionTitle200>> => {
    return axios.put(
      `/sections/revision/title`,
      putSectionsUpdateRevisionTitleBody,options
    );
  }



    export type PutSectionsUpdateRevisionTitleMutationResult = NonNullable<Awaited<ReturnType<typeof putSectionsUpdateRevisionTitle>>>
    export type PutSectionsUpdateRevisionTitleMutationBody = PutSectionsUpdateRevisionTitleBody
    export type PutSectionsUpdateRevisionTitleMutationError = AxiosError<unknown>

    export const usePutSectionsUpdateRevisionTitle = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSectionsUpdateRevisionTitle>>, TError,{data: PutSectionsUpdateRevisionTitleBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSectionsUpdateRevisionTitle>>, {data: PutSectionsUpdateRevisionTitleBody}> = (props) => {
          const {data} = props ?? {};

          return  putSectionsUpdateRevisionTitle(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof putSectionsUpdateRevisionTitle>>, TError, {data: PutSectionsUpdateRevisionTitleBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * oriasReplace.csvからCKEditor原稿の置換データを取得する

 * @summary CKEditor：置換データの取得
 */
export const getCkeditorReplacements = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetCkeditorReplacements200Item[]>> => {
    return axios.get(
      `/ckeditor/replacements`,options
    );
  }


export const getGetCkeditorReplacementsQueryKey = () => [`/ckeditor/replacements`];

    
export type GetCkeditorReplacementsQueryResult = NonNullable<Awaited<ReturnType<typeof getCkeditorReplacements>>>
export type GetCkeditorReplacementsQueryError = AxiosError<unknown>

export const useGetCkeditorReplacements = <TData = Awaited<ReturnType<typeof getCkeditorReplacements>>, TError = AxiosError<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCkeditorReplacements>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCkeditorReplacementsQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCkeditorReplacements>>> = ({ signal }) => getCkeditorReplacements({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getCkeditorReplacements>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

